import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { FacturaService } from 'src/app/services/factura.service';
import { MessagesService } from 'src/app/services/messages.service';
import { Uploads3Service } from 'src/app/services/uploads3.service';
import { SaberRolService } from 'src/app/services/saber-rol.service';
import { GetAniosService } from 'src/app/services/get-anios.service';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { NavigationService } from 'src/app/services/navigation.service';
import { PaginationService } from 'src/app/services/pagination.service';
import { FiltrarProyectosService } from 'src/app/services/filtrar-proyectos.service';
import { FormatoNumberService } from 'src/app/services/formato-number.service';
import { lastValueFrom } from 'rxjs';

import { validacionRolService } from 'src/app/services/validacion-rol.service';

import { MESES } from 'src/app/constants/months.const';

@Component({
  selector: 'app-refacturacion-d',
  templateUrl: './refacturacion-d.component.html',
  styleUrls: ['./refacturacion-d.component.css']
})
export class RefacturacionDComponent {

  public files: NgxFileDropEntry[] = [];
  public hasBaseDropZoneOver = false;
  public filesGrouped: NgxFileDropEntry[][] = [];

  refactura = {
    FKId_Proyecto: 0,
    FacPro_NomProyecto: '',
    FacPro_NoFactura: '',
    FacPro_Descripcion: '',
    FacPro_VoBo: '',
    FacPro_Observaciones: '',
    FacPro_Importe: 0,
    FacPro_FechaIngreso: '',
    FacPro_MesServicio: '',
    FacPro_AnoServicio: '',
    Id_Factura: 0 //Este es el id de la Factura a Refacturar
  }

  opE: any;
  token: any;
  retrievedRefactura: any;

  FacPro_NoFactura: any;
  FacPro_NomProyecto: any;
  FacPro_Importe: any;
  FKId_Proyecto: any;
  FacPro_MesServicio: any;
  FacPro_AnoServicio: any;
  FacPro_FechaIngreso: any;
  Id_Factura: any;
  FacPro_VoBo : string = '';



  // Obtenemos los nuevos datos
  ReFacPro_NoFactura: string = '';
  ReFacPro_Importe: number = 0;
  ReFacPro_FechaIngreso: string = '';
  ReFacPro_MesServicio:string = '';
  ReFacPro_AnoServicio:string = '';


  FacPro_IdFOrigen: any;

  adjuntarFact = false;

  pastAttachments: any[] = []; 
  attachments: any[] = [];
  newdocuments: any[] = [];

  newDocument = {
    FKId_Factura: 0,
    FacDoc_NoFactura: 0,
    FacDoc_URL: '',
    FacDoc_Nombre: ''
  }

  loading = false; // Inicialmente, la carga está desactivada
  loadingDocuments = false;
  progressPercentage = 0;
  message = '';

  //Parametros componet viewpdf
  pdfUrl: string = '';
  modalVisible: boolean = false;
  namepdf: string = '';
  //*
  rol: any;

  showErrorMessageBuscar: boolean = false;
  showErrorMessageFac: boolean = false;
  showErrorMessageImp: boolean = false;
  showErrorMessageIng: boolean = false;
  showErrorMessageMes: boolean = false;
  showErrorMessageAnio: boolean = false;

  mensajeValidacionBuscar: string = '';
  mensajeValidacionFac: string = '';
  mensajeValidacionImp: string = '';
  mensajeValidacionIng: string = '';
  mensajeValidacionMes: string = '';
  mensajeValidacionAnio: string = '';

  mensaje: string = 'Campo requerido.';

  validacionRol = '';

  usuarioId: any;
  iconoMostrar:string = '';
  nameBoton: string = '';

  mostrarBtnReFactura: boolean = false;
  mostrarBtnVoBo: boolean = false;
  validacionCampos: boolean = true;
  anios: string =  '';

  meses = MESES;

  maxFechaHoy:any;

  usarFacturas: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private pagination: PaginationService,
    private UploadService: Uploads3Service,
    private requestsService: FacturaService,
    private getAniosService:GetAniosService,
    private messagesService: MessagesService,
    private saberRolService: SaberRolService,
    private navigationService: NavigationService,
    private validacionBoton: validacionRolService,
    private formatoNumberService: FormatoNumberService,
    private filtrarProyectosService: FiltrarProyectosService
  ) { }


  ngOnInit() {
    const hoy = new Date();
    this.maxFechaHoy = hoy.toISOString().split('T')[0]; 

    this.verificarUsuario();
    this.obtnerIcono();
  }

  obtnerIcono(){
    this.iconoMostrar = this.opE === '1' ? 'bi-arrow-left-circle' : 'bi-x-circle';
    this.nameBoton= this.opE === '1' ? 'Regresar' : 'Cancelar';
  }

  getYears(){
    this.getAniosService.obtenerAnios().subscribe(
      (data: any) => {
        this.anios = data;

        // Verifica si el año seleccionado ya está en la lista
        if (this.anios.includes(this.FacPro_AnoServicio)) {
            this.ReFacPro_AnoServicio = this.FacPro_AnoServicio;
        } else {
            console.warn("El año seleccionado no está en la lista de años disponibles.");
        }

      }, (err) => {
        this.messagesService.showError(err.message);
      });
  }

  verificarUsuario() {
    const { rol, token, usuarioId} = this.filtrarProyectosService.validacionUsuarios();
    this.token = token;
    this.rol = rol;
    this.usuarioId = usuarioId;

    this.navigationService.disableNavigation();
    this.opE = this.route.snapshot.paramMap.get('datos');

    
    if (this.opE === '1') {//obtendgo creditor para actualizar
      this.retrievedRefactura = this.sharedService.getDataArray();
      this.cargarRefactura(this.retrievedRefactura);
    }
    this.getYears();
  }

  esAdministrador(): boolean {
    if (this.rol === 'Administrador' && this.FacPro_VoBo !== 'Aclaracion') {
      return false;
    } else {
      return true;
    }
  }

  async cargarRefactura(getrefactura: any) {
    const data = {
      FacPro_IdFOrigen: getrefactura.FacPro_IdFOrigen
    }
    
    this.requestsService.getobtenerrefactura(getrefactura.Id_Factura, data, this.token).subscribe(
      (res) => {
        if (res?.length) {
          res.forEach((factura:any, index:number) => {
            const tipo = index === 0 ? 'anterior' : 'nuevos';
            this.loadDocuments(factura.Id_Factura, tipo);
          });
        }

        this.FacPro_NoFactura = res[0].FacPro_NoFactura;
        this.FacPro_Importe = res[0].FacPro_Importe;
        this.FacPro_FechaIngreso = this.obtenerFormatoFecha(res[1].FacPro_FechaIngreso);

      }, (err) => {
        this.messagesService.showError('Error al obtener la refacturación');
      }
    )
    this.llenarDatos(getrefactura);
  }

  llenarDatos(getrefactura: any) {
    this.FacPro_VoBo = getrefactura.FacPro_VoBo;
    this.FacPro_NomProyecto = getrefactura.FacPro_NomProyecto;
    this.FacPro_MesServicio = getrefactura.FacPro_MesServicio;
    this.refactura.FacPro_Observaciones = getrefactura.FacPro_Observaciones;
    this.ReFacPro_NoFactura = getrefactura.FacPro_NoFactura;
    this.ReFacPro_Importe = getrefactura.FacPro_Importe;

    // obtenemos el año seleccionado
    this.FacPro_AnoServicio = getrefactura.FacPro_AnoServicio;
    this.getYears();

    this.ReFacPro_MesServicio = getrefactura.FacPro_MesServicio;

    // Funcion que nos ayuda a validar los botones que se tienen quew mostrar
    this.mostrarBtnReFactura = this.validacionBoton.validacionBotonEditar(this.rol, this.FacPro_VoBo,this.opE,'refactura');

    this.mostrarBtnVoBo = this.validacionBoton.validacionBotonVoBo(this.rol, this.FacPro_VoBo,this.opE,'refactura');

    // Funcion que nos ayuda a poner disabled los input que se tienen que mostrar
    this.validacionCampos  = this.validacionBoton.validacionCampos(this.rol, this.FacPro_VoBo,this.opE,'refactura');

    this.ReFacPro_FechaIngreso = this.obtenerFormatoFecha(getrefactura.FacPro_FechaIngreso);
    this.facProImporteAsString();
    this.validacionRol = this.saberRolService.saberRol(getrefactura, this.usuarioId);
  } 

  loadDocuments(Id_Factura: any, tipoDatos: any) {

    this.requestsService.getDocuments(Id_Factura, this.token).subscribe((data: any) => {
      
      if(tipoDatos === 'anterior'){
        this.pastAttachments = data;
      }else{
        this.attachments = data;
      }
      
    }, err => {
      this.messagesService.showError('Error al cargar los documentos');
    });
  }

  obtenerFormatoFecha(fecha: string): string {
    const fechaObj = new Date(fecha);
    const formatoFecha = fechaObj.toISOString().split('T')[0];
    return formatoFecha;
  }

  peticionbuscar() {
    this.requestsService.getbuscarrefactura(this.FacPro_NoFactura, this.token).subscribe(
      (res) => {

        this.Id_Factura = res.Id_Factura;
        this.FacPro_NomProyecto = res.FacPro_NomProyecto;
        this.FacPro_Importe = res.FacPro_Importe;
        this.FKId_Proyecto = res.FKId_Proyecto;
        this.FacPro_FechaIngreso = this.obtenerFormatoFecha(res.FacPro_FechaIngreso);
        this.FacPro_MesServicio = res.FacPro_MesServicio;
        this.FacPro_AnoServicio = res.FacPro_AnoServicio;
        this.messagesService.showMessage('Factura encontrada');

        this.loadDocuments(res.Id_Factura,'anterior');

      }, (err) => {
        
        this.FacPro_NomProyecto = ''
        this.FacPro_Importe = ''
        this.FKId_Proyecto = '';
        this.FacPro_FechaIngreso = '';
        this.FacPro_MesServicio = '';

        if (err.status === 404) {
          const backendMessage = err.error?.message || err.message;
          this.messagesService.showError(backendMessage); // aquí se muestra el mensaje recibido
        } else {
          this.messagesService.showError('Ocurrió un error inesperado');
        }

      }
    )
  }

  Buscar() {
    if (this.FacPro_NoFactura === '' || this.FacPro_NoFactura === undefined) {
      this.showErrorMessageBuscar = true;
      this.mensajeValidacionBuscar = 'Ingresar un valor para buscar';
    } else {
      this.showErrorMessageBuscar = false;
      this.peticionbuscar();
    }
  }


  guardar() {
    if (this.validarCamposVacios()) {
      return; // Si hay campos vacíos, termina la ejecución y no continúa con la edición
    }

    this.regresarNumero();
    this.obtenerFormatoFecha(this.ReFacPro_FechaIngreso,)

    this.refactura = {
      FKId_Proyecto: this.FKId_Proyecto,
      FacPro_NomProyecto: this.FacPro_NomProyecto,
      FacPro_NoFactura: this.ReFacPro_NoFactura,
      FacPro_Descripcion: 'Se Refactura',
      FacPro_Importe: Number(this.ReFacPro_Importe),
      FacPro_FechaIngreso: this.ReFacPro_FechaIngreso,
      FacPro_MesServicio: this.ReFacPro_MesServicio,
      FacPro_AnoServicio: this.ReFacPro_AnoServicio,
      FacPro_VoBo: 'Pendiente',
      FacPro_Observaciones: '',
      Id_Factura: Number(this.Id_Factura)  //Este es el id de la Factura a Refacturar
    }

    this.message = "Guardando ...";
    this.loading = true;
    this.guardarDocumentos();
  }

  guardarDocumentos() {
    this.requestsService.createrefactura(this.refactura, this.token).subscribe(
      (res) => {
        if (this.newdocuments.length >= 1) {
          this.crearFacturas(res.rebill.Id_Factura, res.rebill.FacPro_NoFactura);
        } else {
          this.loading = false;
          this.aceptar(res.message);
        }
      }, (err) => {
        this.messagesService.showError(err.error.error[0].message);
      }
    )
  }

  validarCamposVacios(): boolean {
    
    const camposRequeridos = [
      { campo: this.ReFacPro_NoFactura, nombre: 'No. Factura' },
      { campo: this.ReFacPro_Importe, nombre: 'Importe sin IVA' },
      { campo: this.ReFacPro_FechaIngreso, nombre: 'Fecha de ingreso de facturación' },
      { campo: this.ReFacPro_MesServicio, nombre: 'Mes de servicio' },
      { campo: this.ReFacPro_AnoServicio, nombre: 'Año de servicio' }
    ];
  
    const camposVacios = camposRequeridos
      .filter(item => {
        if (typeof item.campo === 'string') {
          return item.campo.trim() === ''|| item.campo === '0';
        }
        if (typeof item.campo === 'number') {
          return item.campo === null || item.campo === 0;
        }
        return item.campo === null || item.campo === undefined;
      })
      .map(item => item.nombre);
  
    if (camposVacios.length > 0) {
      this.messagesService.showError(`Los siguientes campos están vacíos o tienen valores inválidos: ${camposVacios.join(', ')}`);
      return true; // Hay campos vacíos o inválidos
    }
    
    // Validación adicional: FacPro_NoFactura no debe ser igual a ReFacPro_NoFactura
    if (this.FacPro_NoFactura.trim() === this.ReFacPro_NoFactura.trim()) {
      this.messagesService.showError('La refactura nueva no puede ser igual al número de factura original.');
      return true; // Los números de factura son iguales
    }

    // Validación de documentos: al menos uno de los arreglos debe contener documentos
    if (this.attachments.length === 0 && this.newdocuments.length === 0) {
      this.messagesService.showError('Debe adjuntar al menos un documento para continuar.');
      return true; // No hay documentos adjuntos
    }
  
    return false; // Todos los campos tienen datos válidos
  }
  

  editar() {
    // Validar los campos vacíos antes de proceder
    if (this.validarCamposVacios()) {
      return; // Si hay campos vacíos, termina la ejecución y no continúa con la edición
    }
    // le ponemos las comas a los numeros 
    this.regresarNumero();

    const data: {
      FKId_Proyecto: any;
      FacPro_NomProyecto: any;
      FacPro_NoFactura: any;
      FacPro_Descripcion: string;
      FacPro_Importe: number;
      FacPro_FechaIngreso: any;
      FacPro_MesServicio: any;
      FacPro_AnoServicio: any;
      FacPro_VoBo?: string; // Propiedad opcional
    } = {
      FKId_Proyecto: this.retrievedRefactura.FKId_Proyecto,
      FacPro_NomProyecto: this.retrievedRefactura.FacPro_NomProyecto,
      FacPro_NoFactura: this.ReFacPro_NoFactura,
      FacPro_Descripcion: 'Se Refactura',
      FacPro_Importe: Number(this.ReFacPro_Importe),
      FacPro_FechaIngreso: this.ReFacPro_FechaIngreso,
      FacPro_MesServicio: this.ReFacPro_MesServicio,
      FacPro_AnoServicio: this.ReFacPro_AnoServicio,
      FacPro_VoBo: this.FacPro_VoBo
    };
    
    // Añadimos FacPro_VoBo si se cumple la condición
    if (this.rol === 'Administrador' && this.refactura.FacPro_VoBo === 'VoBo') {
      data.FacPro_VoBo = 'VoBo';
    }else if(this.rol === 'Administrador del proyecto' &&  this.refactura.FacPro_VoBo === 'Aclaracion') { 
      this.refactura.FacPro_VoBo = 'Pendiente';
    }

    this.editarDocumento(data);
  }

  async editarDocumento(data: any) {
    this.requestsService.editfactura(data, this.retrievedRefactura.Id_Factura, this.token).subscribe(
      async (res) => { 
        if (this.newdocuments.length >= 1) {
          
          this.crearFacturas(this.retrievedRefactura.Id_Factura, this.retrievedRefactura.FacPro_NoFactura);

        }else {
          this.loading = false;
          this.aceptar(res.message);
        }
      },
      (err) => {
        this.messagesService.showError(err.message);
      }
    );
  }
  

  crearFacturas(idFactura:any, noFactura:any){
    this.message = "Actualizando Información y Documentos ...."
    this.newDocument.FKId_Factura = idFactura;
    this.newDocument.FacDoc_NoFactura = noFactura;
    this.uploadS3();
  }

  async uploadS3() {
    try {
      this.loadingDocuments = true;
      const totalDocuments = this.newdocuments.length + (this.usarFacturas ? this.attachments.length : 0);
      let processedDocuments = 0;
  
      // PRIMER CASO: Subir archivos nuevos a S3
      if (this.newdocuments.length > 0) {
        for (const documento of this.newdocuments) {
          try {
            const urlFactura = await this.UploadService.uploadToS3('refacturas', documento, this.newDocument.FKId_Factura);
            
            const nuevoDoc = {
              ...this.newDocument, // copia base si ya tiene FKId_Factura
              FacDoc_Nombre: documento.name,
              FacDoc_URL: urlFactura
            };
  
            await this.saveUrl(nuevoDoc);
            processedDocuments++;
            this.progressPercentage = (processedDocuments / totalDocuments) * 100;
          } catch (error) {
            this.messagesService.showError(`Error al subir archivo: ${documento.name}`);
          }
        }
      }
  
      // SEGUNDO CASO: Reutilizar documentos existentes
      if (this.usarFacturas === true) {
        for (const archivo of this.attachments) {
          const nuevoObjeto = {
            FKId_Factura: this.retrievedRefactura.Id_Factura,
            FacDoc_NoFactura: this.retrievedRefactura.FacPro_NoFactura,
            FacDoc_Nombre: archivo.FacDoc_Nombre,
            FacDoc_URL: archivo.FacDoc_URL
          };
  
          await this.saveUrl(nuevoObjeto);
          processedDocuments++;
          this.progressPercentage = (processedDocuments / totalDocuments) * 100;
        }
      }
  
      this.loadingDocuments = false;
      this.loading = false;
      this.aceptar("Factura y documentos Guardados");
      
    } catch (error: any) {
      this.loadingDocuments = false;
      this.loading = false;
      this.messagesService.showError('Error inesperado al guardar los documentos');
    }
  }
  

  async saveUrl(document: any) {
    await lastValueFrom(this.requestsService.SaveDocument(document, this.token));
  }

  // Esta Funcion remueve el documento localmente antes de guardarlo en base de datos
  quitDocument(indexToRemove: any) {
    this.newdocuments.splice(indexToRemove, 1);
  }

  deleteDocumentS3(document: any) {
    this.loading = true;
    this.message = "Eliminando Documento ....";
    this.UploadService.deleteFileS3('refacturas', document.FKId_Factura, document.FacDoc_Nombre).then((res: any) => {
      this.requestsService.deleteDocument(document.Id_Documento, this.token).subscribe(
        (resp: any) => {
          this.loading = false;
          this.loadDocuments(this.retrievedRefactura.Id_Factura,'nuevos')
          this.messagesService.showMessage(res);
        }, (error) => {
          this.loading = false;
          this.messagesService.showError(error);
        })
    }, (error) => {
      this.loading = false;
      this.messagesService.showError(error);
      return;
    });
  }

  eliminar() {
    const data = {
      Id_Factura: Number(this.retrievedRefactura.FacPro_IdFOrigen)
    }
    this.requestsService.deleterefactura(this.retrievedRefactura.Id_Factura, data, this.token).subscribe(
      (res) => {
        this.aceptar(res.message);
      },(err) => {
        this.messagesService.showError(err.message);
      }
    )
  }

  aceptar(message: string) {
    this.messagesService.showMessage(message);
    this.cancelar();
  }

  cancelar() {
    this.pagination.setLastAction('back');
    this.router.navigate(['/refacturacion']);
  }

  public dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          if (this.isPDF(file)) {
            const formData = new FormData();
            this.newdocuments.push(file);
          } else {
            console.error('Error: El archivo no es un PDF.');
            this.messagesService.showError('El archivo no es un PDF.');
            // Aquí puedes agregar lógica para notificar al usuario que solo se permiten archivos PDF.
          }
        });
      }
    }
  }

  private isPDF(file: File): boolean {
    return file.type === 'application/pdf';
  }

  public fileOver(event: any) {
    // // console.log(event);
  }

  public fileLeave(event: any) {
    // // console.log(event);
  }

  cambioEstatus() {
    const data = {
      FacPro_VoBo: "VoBo" //"Pendiente", "Aclaración", "VoBo"
    }
    this.requestsService.cambioEstatusR(data, this.retrievedRefactura.Id_Factura, this.token).subscribe(
      (res) => {
        this.aceptar(res.message);
      }, (err) => {
        this.messagesService.showError('Error al enviar el estatus.');
      }
    )
  }

  comentarios() {
    if (this.refactura.FacPro_Observaciones === '') {
      this.messagesService.showError('Es necesario colocar algún comentario.');
    } else {
      this.enviarComentario();
    }
  }

  enviarComentario() {
    const data = {
      FacPro_Observaciones: this.refactura.FacPro_Observaciones, //string
      FacPro_VoBo: "Aclaracion" //"Pendiente", "Aclaración", "VoBo"
    }
    this.requestsService.comentariosR(data, this.retrievedRefactura.Id_Factura, this.token).subscribe(
      (res) => {
        this.aceptar(res.message)
      }, (err) => {
        this.messagesService.showError('Error al enviar el comentario.');
      }
    )
  }

  async openModal(document: any, folder: string) {
    try {
      this.pdfUrl = await this.UploadService.getViewUrl(folder, document.FKId_Factura, document.FacDoc_Nombre);
      this.namepdf = document.FacDoc_Nombre;
      this.modalVisible = true;
    } catch (error: any) {
      this.messagesService.showError(error?.message || 'No se pudo abrir el documento.');
    }
  }

  async downloadDocument(document: any, folder: string) {
    try {
      const url = await this.UploadService.getViewUrl(folder, document.FKId_Factura, document.FacDoc_Nombre);
      window.open(url, '_blank');
    } catch (error: any) {
      this.messagesService.showError(error?.message || 'No se pudo descargar el documento.');
    }
  }

  onModalClosed() {
    this.modalVisible = false;
  }

  // regresar a numero 
  regresarNumero() {
    let ingresado = this.ReFacPro_Importe;
    this.ReFacPro_Importe = this.formatoNumberService.regresarNumero(ingresado);
  }

  // funcion que nos permite poner las comas en los digitos
  facProImporteAsString(): any {
    let ingresado = this.ReFacPro_Importe;
    this.ReFacPro_Importe = this.formatoNumberService.facProImporteAsString(ingresado);
  }

  // Método para filtrar caracteres no numéricos y puntos
  filterInput(event: any): void {
    let inputValue = event.target.value;

    // Permitir solo números y un solo punto decimal
    let sanitizedValue = inputValue.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

    // Verificar si el valor contiene un punto decimal
    if (sanitizedValue.indexOf('.') !== -1) {
      // Dividir el número en partes entera y decimal
      let partes = sanitizedValue.split('.');

      // Limitar la parte decimal a 2 dígitos
      let decimalPart = (partes[1] || '').substring(0, 2);

      // Formatear la parte entera con comas
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // Unir la parte entera con la parte decimal
      sanitizedValue = `${partes[0]}.${decimalPart}`;
    } else {
      // Si no hay punto decimal, solo agregar comas a la parte entera
      sanitizedValue = sanitizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // Actualizar el valor del campo
    event.target.value = sanitizedValue;
    this.facProImporteAsString();
  }

  emparejarDocumentos(){
    this.attachments = this.pastAttachments;
    this.usarFacturas = true;
  }

  mostrarMensaje(campo: any, tipo: string) {
    switch (tipo) {
      case 'factura':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageFac = true;
          this.mensajeValidacionFac = this.mensaje;
        } else {
          this.showErrorMessageFac = false;
        }
      break;

      case 'importe':
        if (campo.invalid && (campo.dirty || campo.touched) || this.ReFacPro_Importe === 0) {
          this.showErrorMessageImp = true;
          this.mensajeValidacionImp = this.mensaje;
        } else {
          this.showErrorMessageImp = false;
        }
      break;

      case 'ingreso':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageIng = true;
          this.mensajeValidacionIng = this.mensaje;
        } else {
          this.showErrorMessageIng = false;
        }
      break;

      case 'ingreso':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageIng = true;
          this.mensajeValidacionIng = this.mensaje;
        } else {
          this.showErrorMessageIng = false;
        }
      break;
      case 'mes':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageMes  = true;
          this.mensajeValidacionMes = this.mensaje;
        } else {
          this.showErrorMessageMes = false;
        }
        break;

      case 'anio':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageAnio  = true;
          this.mensajeValidacionAnio = this.mensaje;
        } else {
          this.showErrorMessageAnio = false;
        }
      break;
    }
  }
}
